import React from "react";
import { Link } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { useContent } from "@/context/ContentContext";

export default function Warranty() {
  const c = useContent();
  const w = c.warranty || {};
  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-14 sm:py-20">
        <span className="font-mono text-xs tracking-[0.2em] uppercase text-[#8CE63C]">Peace of Mind</span>
        <h1 className="font-display text-4xl sm:text-5xl font-black text-white uppercase tracking-tight mt-4">Warranty</h1>
        <p className="text-[#9EABA0] text-sm sm:text-base leading-relaxed mt-4 max-w-2xl">{w.intro}</p>

        <div className="mt-8 rounded-2xl border border-[#232f25] bg-[#111712] overflow-hidden" data-testid="warranty-table">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-[#0d120e] border-b border-[#232f25]">
                <th className="text-left px-5 sm:px-6 py-4 font-mono text-[11px] uppercase tracking-wider text-[#8CE63C]">Coverage</th>
                <th className="text-left px-5 sm:px-6 py-4 font-mono text-[11px] uppercase tracking-wider text-[#8CE63C]">Policy for each model</th>
              </tr>
            </thead>
            <tbody>
              {(w.rows || []).map((r, i) => (
                <tr key={i} className={i % 2 ? "bg-[#0d120e]" : "bg-[#111712]"}>
                  <td className="px-5 sm:px-6 py-4 font-semibold text-white border-b border-[#1a211b] align-top whitespace-nowrap">{r.coverage}</td>
                  <td className="px-5 sm:px-6 py-4 text-[#9EABA0] border-b border-[#1a211b] leading-relaxed">{r.policy}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="text-xs text-[#69776b] mt-5 leading-relaxed">
          {w.footnote} <Link to="/contact" className="text-[#8CE63C] hover:underline">Contact us</Link>.
        </p>
      </div>
    </Layout>
  );
}
